import { render, staticRenderFns } from "./StudentOrderListPage.vue?vue&type=template&id=51b0d247&"
import script from "./StudentOrderListPage.vue?vue&type=script&lang=js&"
export * from "./StudentOrderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports